// test592
(592 && 0);
